var React = require('react');

function ChevrondownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.7277 7.51545L18.8438 6.626C18.634 6.41487 18.2947 6.41487 18.0849 6.626L10 14.7434L1.91521 6.626C1.70539 6.41487 1.36611 6.41487 1.15628 6.626L0.272356 7.51545C0.0625349 7.72659 0.0625349 8.06799 0.272356 8.27913L9.62057 17.6858C9.83039 17.8969 10.1697 17.8969 10.3795 17.6858L19.7277 8.27913C19.9375 8.06799 19.9375 7.72659 19.7277 7.51545Z","fill":"white"}));
}

ChevrondownInline.defaultProps = {"width":"20","height":"23","viewBox":"0 0 20 23","fill":"none"};

module.exports = ChevrondownInline;

ChevrondownInline.default = ChevrondownInline;
